import { Subject } from "rxjs";
import { BaseEntity } from "../../core/baseEntity.model";

export class BaseEntityService<T extends BaseEntity<T>, M> {
    public isModalOpen: boolean = false;
    public editingEntity: M;

    protected initialized: boolean = false;

    public get isLoading(): boolean {
      return this.loading > 0;
    }
    private _loading: number = 0;
  
    protected get loading() {
      return this._loading;
    }
  
    protected set loading(value) {
      this._loading = Math.max(value, 0);
    }
  
    public onCreateObservable = new Subject<T>();
    onCreateObservable$ = this.onCreateObservable.asObservable();
  
    public onChangeObservable = new Subject<T>();
    onChangeObservable$ = this.onChangeObservable.asObservable();  
        

    public startLoading() {
      this.loading++;
    }
    public stopLoading() {
      this.loading--;
    }

    public publishOnChange(entity?: T) {
      this.onChangeObservable.next(entity as any);
    }
}